export var SubscriptionLog = /*@__PURE__*/ (/*@__PURE__*/ function () {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) {
            unsubscribedFrame = Number.POSITIVE_INFINITY;
        }
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}());
//# sourceMappingURL=SubscriptionLog.js.map



//////////////////
// WEBPACK FOOTER
// /ng-app/node_modules/rxjs/_esm5/testing/SubscriptionLog.js
// module id = ../../../../rxjs/_esm5/testing/SubscriptionLog.js
// module chunks = vendor